import script from "./DealQuotationDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./DealQuotationDetails.vue?vue&type=script&setup=true&lang=js"

import "./DealQuotationDetails.vue?vue&type=style&index=0&id=dc802e0e&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc802e0e"]])

export default __exports__